import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog, IDialogDataWithTicketType } from '../dialog';
import { TextInputComponent } from '../../data-input/form-inputs/text-input/text-input.component';
import { ButtonComponent } from '../../feedback/button/button.component';
import { EEntityType, ERelationType } from '@web/dtos';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CmsTicketCategoryService } from '../../../services/cms-ticket-category/cms-ticket-category.service';

interface ITicketCategoryNameForm {
  name: FormControl<string | null>;
}

@Component({
  selector: 'aw-ticket-category-add-dialog',
  imports: [
    CommonModule,
    DialogComponent,
    TextInputComponent,
    ButtonComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './ticket-category-add-dialog.component.html',
})
export class TicketCategoryAddDialogComponent extends Dialog<IDialogDataWithTicketType> {
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;
  public cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  public fb: FormBuilder = inject(FormBuilder);
  public form: FormGroup<ITicketCategoryNameForm> = this.fb.group({
    name: ['', Validators.required],
  });
  private readonly cmsTicketCategoryService: CmsTicketCategoryService = inject(
    CmsTicketCategoryService
  );

  addNewCategory(name: string | null | undefined): void {
    if (!name) {
      return;
    }

    this.cmsTicketCategoryService.addTicketCategory(name, this.data.ticketType);
    this.dialogRef.close();
  }
}
